<div class="d-flex align-self-baseline mt-3">
  <div class="card fitting-cards flex-fill">
    <div class="card-header text-center bg-dark bg-gradient text-white"><b>Filtered Pipeline Fitting Products</b>
      <span class="lilbtn" *ngIf="isFittingsAdmin$|async">
        <app-export-excel [docType]="doc" [data]="results"></app-export-excel>
      </span>
    </div>
    <div class="card-body query-result">
      <ng-template #noProducts><small>There are no available products for the current filter.</small></ng-template>
      <ng-template #filterMinimum><small class="text-danger fw-bold">Please select a region and pipe size.</small>
      </ng-template>
      <ng-container *ngIf="!isLoading else loader">
        <ng-container *ngIf="!!query && (query.pipeSizeId || -1) > -1 && (query.hemisphereId || -1) > -1 else filterMinimum">
          <ul class="list-group list-group-flush p-0" *ngIf="results.length > 0 else noProducts">
            <li *ngFor="let item of results; let i=index;" class="list-group-item py-1 clickable px-1" [class.active]="active === item.id && activePartNumber === item.partNumber" [ngClass]="{'bg-stripe': i % 2 ===0 }"
              (click)="setActiveFitting.emit({id: item.id, partNumber: item.partNumber})">

              <div class="d-flex">
                <div class="d-flex flex-column w-100">
                  <small class="d-flex">
                    <b>{{item.partNumber}}</b>
                    <i *ngIf="item.isBuyAmerica" [ngClass]="{'text-white': item.id && activePartNumber === item.partNumber, 'text-primary': !item.id || activePartNumber !== item.partNumber}" class="fas fa-flag-usa fs-6 ms-2" ngbTooltip="This is a Buy America product"></i>

                  </small>
                  <small>{{item.description}}</small>
                </div>

                <i *ngIf="item.isPreferred" class="fa fa-star with-shadow fs-4 ms-auto my-auto mx-1" ngbTooltip="Preferred Product"></i>
              </div>

            </li>
          </ul>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #loader>
  <div class="d-flex" style="height: 12rem;">
    <div class="loader loader-dark"></div>
  </div>
</ng-template>
